<div
  class="sidebar"
  (mouseenter)="openSidebar()"
  (mouseleave)="closeSidebar()"
  [class.sidebar--collapsed]="!isSidebarOpen"
>
  <div class="sidebar__menu">

    <!-- Inicio (home) -->
    <app-sidebar-item
      title="Inicio"
      icon="home"
      [activeSignal]="activeItem"
      route="/dashboard"
    />

    <!-- Proveedores -->
    @if (isProveedorProducto()) {
      <app-sidebar-item
        title="Despachos"
        [activeSignal]="activeItem"
        route="/proveedores/despachos"
      />
      <app-sidebar-item
        title="Órdenes de compra"
        [activeSignal]="activeItem"
        route="/proveedores/ordenes-compra"
      />
    }
    @if (!isProveedorProducto()) {
      <app-sidebar-item
        title="Importaciones"
        [activeSignal]="activeItem"
        route="/proveedores/importaciones"
      />
      <app-sidebar-item
        title="Tarifas"
        [activeSignal]="activeItem"
        route="/tarifas/solicitudes"
      />
    }

    <!-- Carga masiva de terceros -->
    <app-sidebar-item
      title="Carga masiva de terceros"
      icon="group_add"
      [activeSignal]="activeItem"
      route="/herramientas/carga-masiva-terceros"
    />

  </div>

</div>
